// extracted by mini-css-extract-plugin
module.exports = {"listItemDetails":"listItemDetails__TdHuk"};